$('.primary-nav__item').keydown(function(e){
  
  if ([37,38,39,40].indexOf(e.keyCode) == -1) {
      return;
  }

  var link = $(this);

  switch(e.keyCode) {
      case 37:
          e.preventDefault();
          e.stopPropagation();
          if(!link.parent().hasClass("dropdown")){
            if(link.is(':first-child')) {
              link.parent().last().find("a").focus()
            } else {
              link.prev().find("a").focus() 
            }  
          }
          else{
            var dropdown = link.parent().parent();
            var navLink = dropdown.find(".primary-nav__item--top").first()
            navLink.prev().focus()
          }
          break;

      case 38: 
      e.preventDefault();
      e.stopPropagation();

        if(link.parent().hasClass("dropdown")){
          if(link.is(':first-child')) {
              link.parent().last().find("a").focus()
          } else {
              link.prev().find("a").focus()
          }
        }
          break;
      case 39:
          e.preventDefault();
          e.stopPropagation();
          if(!link.parent().hasClass("dropdown")){
            if(link.is(':last-child')) {
              link.parent().first().find("a").focus()
            } else {
             
              link.next().find("a").focus()
            }
          }
          else{
            var dropdown = link.parent().parent();
            var navLink = dropdown.find(".primary-nav__item--top").first()
            navLink.next().focus()
          }
          break;

      case 40:
          e.preventDefault();
          e.stopPropagation();

          if(link.parent().hasClass("dropdown")){
          
              if(link.is(':last-child')) {
                  ink.parent().first().find("a").focus()
              } else {
                link.next().find("a").focus()
                break;   
              }
              
          }
          else {
              var dropdown = link.find(".dropdown").first();

              if(dropdown.length > 0){
                   dropdown.find("a").eq(2).focus();
              }
          }
          break;    
  }
});